export default __webpack_public_path__ + "static/media/10.917d4872.PNG";